export const hasAllReportsSaaSProduct = location => {
  const isSaasPlanPresent =
    location.settings?.saas_settings?.saas_mode === 'activated' && location.settings?.saas_settings?.saas_plan_id
  if (!isSaasPlanPresent) return true

  const saasProducts = Array.isArray(location.settings?.saas_settings?.saas_products)
    ? location.settings?.saas_settings?.saas_products
    : typeof location.settings?.saas_settings?.saas_products === 'object'
    ? Object.values(location.settings?.saas_settings?.saas_products)
    : null

  if (!saasProducts || saasProducts.length === 0 || saasProducts.includes('all-reports')) return true
  return false
}
